module.exports = __webpack_public_path__ + "static/img/IMG_20240210_173619_1.29114147.jpg";